import React from 'react'
import { observer } from 'mobx-react'
import { observable } from 'mobx'
import { Row, Button } from 'react-bootstrap'
import {
  IoMdFunnel as RefineIcon,
  IoIosCloseCircle as CloseIcon,
} from 'react-icons/io'
import filterIcon from 'src/images/filter.svg'
import { catalogDeps } from 'src/deps'
import { i18nTranslate, application, enablePlpRedesign } from 'src/utils'

@observer
class MobileFilterHeader extends React.Component {
  @observable refineButtonRef = React.createRef()

  componentDidMount() {
    if (this.props.isDragFacetListFilterOpen) {
      this.refineButtonRef.current.focus()
    }
  }

  render() {
    const { toggleFilter, handleReset } = this.props
    return (
      <Row
        className={`filter-header ${enablePlpRedesign() ? 'align-items-baseline' : 'align-items-center'} py-2 mb-0 border-light`}
        data-testid="qa-plp-refine-label"
        noGutters>
        {enablePlpRedesign() && application?.isMobile && (
          <div className="filter-text">
            {i18nTranslate('category_page.filter', 'Filters', {
              nameSpace: this.nameSpace,
            })}
          </div>
        )}
        <Button
          className={`refine-button border-0 p-0 d-md-none bg-transparent ${enablePlpRedesign() ? 'd-none' : ''}`}
          onClick={toggleFilter}
          variant="outline-dark"
          aria-label="refine"
          ref={this.refineButtonRef}
          aria-expanded={!catalogDeps.showProductBlock}>
          <RefineIcon className="refine-icon" />
        </Button>
        <div className="refine-container d-none d-md-flex">
          <h2
            className="refine-text font-weight-bold text-uppercase"
            data-testid="qa-plp-filter-by">
            {i18nTranslate('plp.filterTitle', 'Filter By', {
              nameSpace: 'ssr-resource',
            })}
          </h2>
          <img
            className="refine-icon"
            src={filterIcon}
            alt=""
            data-testid="qa-plp-refine-icon"
          />
        </div>
        <Button
          className="reset-button align-items-center border-0 p-0 d-flex ml-3 bg-transparent"
          data-testid="qa-plp-reset"
          onClick={handleReset}
          variant="outline-dark">
          <span className="reset-text">
            {i18nTranslate('plp.clearFilter', 'Clear All', {
              nameSpace: 'ssr-resource',
            })}
          </span>
          {/* <ResetIcon
            className="reset-icon"
            aria-label={i18nTranslate('icons.reset', 'reset catalog filter')}
          /> */}
        </Button>
        <Button
          className="close-button  d-md-none border-0 p-0"
          onClick={toggleFilter}
          variant="outline-dark">
          <CloseIcon
            className="close-icon"
            aria-label={i18nTranslate('icons.close', 'close icon', {
              nameSpace: 'ssr-resource',
            })}
          />
        </Button>
      </Row>
    )
  }
}

export { MobileFilterHeader }
